import { render, staticRenderFns } from "./otherFeeList.vue?vue&type=template&id=4f7ddf61&scoped=true"
import script from "./otherFeeList.vue?vue&type=script&lang=js"
export * from "./otherFeeList.vue?vue&type=script&lang=js"
import style0 from "./otherFeeList.vue?vue&type=style&index=0&id=4f7ddf61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ddf61",
  null
  
)

export default component.exports